<template>
  <icon
    v-if="!hideHelp"
    name="help_outline"
    class="help-icon"
    v-tooltip="{ content: helpText, delay: 100, placement: 'bottom' }"
  />
</template>

<script>
import Icon from './Icon';

export default {
  components: {
    Icon,
  },

  props: {
    hideHelp: Boolean,
    helpText: String,
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.help-icon {
  font-size: 12px;
  cursor: help;
  margin-left: 3px;

  @media($medium-down) {
    display: none;
  }
}
</style>
